/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../application";
import { getErrorMessage } from "../utils/error.message";
import { GET_PRODUCTS } from "../pages/AddYourProduct/graphql/getProducts.query";
import {
    batch_choose_form,
    batch_choose_form_fields,
    batch_form,
    batch_form_fields,
    batch_selection_form,
    batch_selection_form_fields,
    gtin_form,
    gtin_form_fields,
    product_choose_form,
    product_choose_form_fields,
    product_form,
    product_form_fields,
    product_selection_form,
    product_selection_form_fields,
    provenance_form,
    provenance_form_fields,
    variant_choose_form,
    variant_choose_form_fields,
    variant_selection_form,
    variant_selection_form_fields,
} from "../pages/AddYourProduct/config/formData";
import { GET_GTINS } from "../pages/AddYourProduct/graphql/getGTINs.query";
import { CREATE_PRODUCT } from "../pages/AddYourProduct/graphql/create-product.mutation";
import { UPLOAD_FILE } from "../pages/AddYourProduct/graphql/upload-image.mutation";
import { CREATE_BATCH } from "../pages/AddYourProduct/graphql/create-batch.mutation";
import { CREATE_GTIN } from "../pages/AddYourProduct/graphql/create-gtin.mutation";
import { v4 as uuidv4 } from "uuid";
import { dynamicData } from "../widgets/Flinstone/libs/DynamicFields.lib";
import { CREATE_PROVENANCE } from "../pages/AddNewProvenance/graphql/create-provenance.mutation";
import { ASSOCIATE_PROVENANCE } from "../pages/AddNewProvenance/graphql/associate.mutation";
import { CHECK_BATCH } from "../pages/AddNewProvenance/graphql/checkBatch.query";

const is = require("is_js");

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "addNewCollection.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class AddNewCollectionService {
    name = SERVICE_NAME;
    private static instance: AddNewCollectionService;
    private constructor() {
        console.log("on addNewCollection.service");
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new AddNewCollectionService();
        }
        return this.instance;
    }
    _getProductField(data: any) {
        let _data: any[] =
            data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                return {
                    label: item?.name,
                    value: item?._id,
                };
            });
        console.log("_data1", _data);
        if (_data) {
            let formFields =
                product_selection_form &&
                product_selection_form.map((item: any, index: number) => {
                    if (item?.name === "SelectProduct") {
                        return {
                            ...item,
                            fieldProps: {
                                ...item?.fieldProps,
                                initialOptions: _data,
                            },
                        };
                    } else {
                        return { ...item };
                    }
                });
            return formFields;
        }
    }
    _getProvenancetField(data: any) {
        let _data: any[] =
            data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                if (item?.type === "Batch") {
                    return {
                        label: `${item?.name} (Batch Level)`,
                        value: item?._id,
                    };
                } else if (item?.type === "Product") {
                    return {
                        label: `${item?.name} (Product Level)`,
                        value: item?._id,
                    };
                }
            });
        console.log(_data);
        if (_data) {
            let formFields =
                provenance_form &&
                provenance_form.map((item: any) => {
                    if (item?.name === "SelectTemplate") {
                        return {
                            ...item,
                            fieldProps: {
                                ...item?.fieldProps,
                                initialOptions: _data,
                            },
                        };
                    } else {
                        return { ...item };
                    }
                });
            return formFields;
        }
    }

    async getProductForm() {
        console.log("getProduct cm1");
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PRODUCTS,
                    variables: {},
                    fetchPolicy: "network-only",
                });
                if (res?.data?.getProducts) {
                    const _arr = [
                        {
                            key: "quantity",
                            value: "",
                        },
                        {
                            key: "ingredients",
                            value: "",
                        },
                        {
                            key: "instructions",
                            value: "",
                        },
                    ];
                    let _arr2: any = [];
                    _arr &&
                        _arr.map((item: any, index: number) => {
                            if (
                                item?.key.toLowerCase() !== "name" &&
                                item?.key.toLowerCase() !== "updated at"
                            )
                                _arr2.push({
                                    ...item,
                                    id: uuidv4(),
                                });
                        });
                    dynamicData.update(_arr2);
                    return {
                        productDetails: {
                            choose: {
                                fields: product_choose_form_fields,
                                formFields: product_choose_form,
                            },
                            existingproduct: {
                                fields: product_selection_form_fields,
                                formFields: this._getProductField(
                                    res?.data?.getProducts?.data
                                ),
                            },
                            newproduct: {
                                fields: product_form_fields,
                                formFields: product_form,
                            },
                        },
                        variantDetails: {
                            choose: {
                                fields: variant_choose_form_fields,
                                formFields: variant_choose_form,
                            },
                            existingvariant: {
                                fields: variant_selection_form_fields,
                                formFields: variant_selection_form,
                            },
                            newvariant: {
                                fields: gtin_form_fields,
                                formFields: gtin_form,
                            },
                        },
                        BatchDetails: {
                            choose: {
                                fields: batch_choose_form_fields,
                                formFields: batch_choose_form,
                            },
                            existingBatch: {
                                fields: batch_selection_form_fields,
                                formFields: batch_selection_form,
                            },
                            newBatch: {
                                fields: batch_form_fields,
                                formFields: batch_form,
                            },
                        },
                        provenanceDetails: {
                            newProvenance: {
                                fields: provenance_form_fields,
                                formFields: this._getProvenancetField(
                                    res?.data?.getProvTemplates
                                ),
                            },
                            templates: res?.data?.getProvTemplates,
                        },
                    };
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }
    async getGtins(id: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_GTINS,
                    variables: {
                        where: {
                            productId: id,
                        },
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data?.getGtinsByProductID) {
                    return { gtins: res?.data?.getGtinsByProductID };
                }
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            console.log("display message1", _display_message);
            if (_display_message.message === "Varinat not found") {
                return { gtins: [] };
            }
            getErrorMessage(err);
        }
    }

    async createProductCollection(payload: any) {
        log.blue(`upload data in service:`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_PRODUCT,
                    variables: {
                        name: payload?.name,
                        desc: payload?.desc,
                        attrs: payload?.attrs,
                        assets: {
                            imgs: payload?.imgs,
                            videos: payload?.videos,
                        },
                        // brand: "614adb9996cce558bc4a6e1b",
                    },
                    fetchPolicy: "no-cache",
                });
                console.log(
                    "response on createProduct",
                    res,
                    res?.data?.createProduct
                );
                if (res?.data?.createProduct) {
                    return { ...res?.data?.createProduct };
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async createGtinCollection(payload: any) {
        log.blue(`upload data in service:`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_GTIN,
                    variables: {
                        name: payload?.name,
                        desc: payload?.desc,
                        attrs: payload?.attrs,
                        assets: {
                            imgs: payload?.imgs,
                        },
                        item: payload?.productId,
                        gtinKey: payload?.gtinKey,
                    },
                    fetchPolicy: "no-cache",
                });
                if (res?.data?.createGtin) {
                    return res?.data?.createGtin;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async createBatchCollection(payload: any) {
        log.blue(`upload data in service:`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_BATCH,
                    variables: {
                        where: {
                            productId: payload?.productId,
                        },
                        data: {
                            name: payload?.name,
                            description: payload?.description,
                            variants: [payload?.gtinId],
                            //    creatorUser: "6193941de1204414dfad500f"
                        },
                    },
                    fetchPolicy: "no-cache",
                });
                if (res?.data?.createBatch) {
                    return res?.data?.createBatch;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async uploadFile(payload: any) {
        log.info(`payload in uploadFiel service:`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPLOAD_FILE,
                    variables: {
                        ...payload,
                    },
                    fetchPolicy: "no-cache",
                });
                if (res?.data?.uploadFile) {
                    return { image: res?.data?.uploadFile };
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async createProvenance(payload: any) {
        log.success("in create provenance service:", payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                log.blue(
                    `in provenance create service payload bla bla :: :`,
                    payload
                );
                const res = await client.mutate({
                    mutation: CREATE_PROVENANCE,
                    variables: {
                        name: payload?.name,
                        provSteps: payload?.provSteps,
                        provenanceTemplate: payload?.provenanceTemplate,
                    },
                    fetchPolicy: "no-cache",
                });
                log.info(`data in createProvenance::`, res);
                if (res?.data?.createProvenance) {
                    return { ...res?.data?.createProvenance };
                }
            }
        } catch (err: any) {
            log.blue(`error in createProvenance :`, err?.target);
            log.blue(`error in gQL :`, err?.graphQLErrors);
            getErrorMessage(err);
        }
    }

    async associateProvenance(payload: any) {
        log.success('in associateProvenance',payload)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                log.blue(`in provenance associate service payload :`, payload);
                const res = await client.mutate({
                    mutation: ASSOCIATE_PROVENANCE,
                    variables: {
                        ...payload,
                    },
                    fetchPolicy: "no-cache",
                });
                if (res?.data?.updateProvenance) {
                    return res?.data?.updateProvenance;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async checkProvBatch(payload: any) {
        log.success('in checkProvBatch',payload)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: CHECK_BATCH,
                    variables: {
                        ...payload,
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data?.checkProvForDefaultBatch) {
                    return res?.data?.checkProvForDefaultBatch;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
